import { requestWithToken as request } from './api'

export const getAdminAction = (params = {}) => {
  return request.get('/custom_admin/admin_action/actions/?format=json',
    params)
}

export const adminAction = (params = {}) => {
  return request.post('/custom_admin/admin_action/actions/?format=json',
    params)
}
